<template>
<div style="overflow:hidden">

    <div class='wrapper'>
       <div class='add_course_head'>
            <div></div>
            <div>学员管理</div>
            <div class="add_course_head_save">
            
            </div>
        </div>
        <div class="content">
            <div class="class_list">
                <div class="class_list_head">
                    <div :class="{class_list_head_active:class_list_head_active==1}" style="width:100%;text-align:center" >班级</div>
                </div>
                <div class="class_list_content">
                    <div @click="item.id==current_class_id?'':(page_num=1,get_current_class(item))"   v-for="(item,index) in class_lsit" :key="index">
                       <div  :class="{current_class:current_class_id==item.id}" class="class_list_content_item" style="display:flex;justify-content: space-between"> 
                            <div> {{item.name}}
                              <!-- <span> ({{item.student_json!='' ?item.student_json.split(',').length:0}})</span> -->
                              </div>
                           
                       </div>
                    </div>
                </div>
                
            </div>
            <div class="content_right">
                <div class="right_head">
                    <div>{{current_class.name}}</div>
                   
                </div>
                <div class="right_table">
                <el-table
                    :data="student_details_list"
                    @sort-change="sort_change"
                    style="width: 100%"
                    height="100%"
                    border
                    
                    >
                    
                    <el-table-column
                        prop="name"
                        label="姓名"
                        width="120"
                        
                    >
                    </el-table-column>
                    <el-table-column
                        prop="credit"
                        label="学分"
                        width="100"
                        sortable='custom'
                        
                    >
                    </el-table-column>
                    
                    <el-table-column
                        prop="subjects"
                        label="助教学科"
                     
                    >
                    </el-table-column>
                     <el-table-column
                        prop="count"
                        label="批改次数"
                        width="120"
                        sortable='custom'
                    >
                    </el-table-column>

                    <el-table-column
                       align="right"
                         
                    >
                     <template slot="header" slot-scope="scope">
                      <el-input
                        @input="forceUpdate"
                        v-model="search_name"

                        placeholder="输入关键字搜索"/>
                    </template>
                     <template slot-scope="scope">
                         <div >
                             <div @click="set_assistant(scope.row)" class="operation_btn">设为助教</div>
                             <div @click="cancle_assistant(scope.row)" class="operation_btn" style="border-color:red;color:red">取消助教</div>
                            
                         </div>
                     </template>
                       
                    </el-table-column>
                   
                    </el-table>
                   
                </div>
                <div class="student_pagination">
                  <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="student_total"
                      @current-change="change_page"
                      
                      >
                    </el-pagination>
                </div>
                    
                <div ></div>
            </div>
        </div>
     
    
    </div>
</div>
    
</template>

<script>

export default {

  data() {
    return {
      order_type:null,
      order_by:null,
      teacher_subject:[],//教师学科列表
      page_size:10,
      page_num:1,
      student_total:0,
      search_name:'',

      
      tool_checkList:['金山词霸'],
        setting_tool:false,
        tool_list:[],
        dia_txt:'挑选班级',
        add_class_dig:false,
        add_to_group_dig:false,
        class_list_head_active:1,
        class_lsit:[],
        current_class_id:0,
        current_class:{},
        student_details_list:[],
        multipleSelection:[],
        select_grouping:{},
        class_lsit_add:[],//物理班级列表
        select_class:{},
        //座位表
         present_settingPlan:'',
        dialog_creat_seatingPlan:false,
         creat_column:8,
        creat_row:6,
        dialog_seatingPlan:false,
        seat_table:[],
     students_right:[],
      student_left_active:-1,
      student_right_active:-1,
      
        
    };
  },
  //监听路由变化 控制首页背景图
  watch: {

  },
  created() {

  },

  beforeMount() {
 
  },
  mounted() {
      this.get_class()
      // 获取教师学科
      this.axios.get("/bank/system/v1.0/teacher/subjects").then(res => {
        // console.log(res.data.data)
        this.teacher_subject=[res.data.data[0].id]
      })
     
  },
  methods: {
    //搜索
    forceUpdate() {
     
    
        this.page_num=1
        this.get_current_class(this.current_class)
      
      this.$forceUpdate()
      
    },
    // 分页
    change_page(page){
      this.page_num=page
      this.get_current_class(this.current_class)
    },
    // 排序
    sort_change(column){
      // console.log(column)
      this.order_type=column.order,
      this.order_by=column.prop
      this.get_current_class(this.current_class)
  
    },
   
    // 设为助教/取消助教
    set_assistant(row){
   
      let params={
        classId: this.current_class_id,
        subjectIds:this.teacher_subject
      }
      this.axios.post("/bank/system/v1.0/student/"+row.id+"/assistant",params).then(res => {
          if (res.data.code == 200) {
               this.$message({
                  message: res.data.message,
                  type: "success",
                  duration:1500,showClose: true
              });
              this.get_current_class(this.current_class)
            } else {
              this.$message({
                  message: res.data.message,
                  type: "error",
                  duration:1500,showClose: true
              });
            }
      })

    },
    cancle_assistant(row){
       let params={
        classId: this.current_class_id,
        subjectIds:this.teacher_subject
      }
      this.axios.delete("/bank/system/v1.0/student/"+row.id+"/assistant",{data:params}).then(res => {
          if (res.data.code == 200) {
               this.$message({
                  message: res.data.message,
                  type: "success",
                  duration:1500,showClose: true
              });
              this.get_current_class(this.current_class)
            } else {
              this.$message({
                  message: res.data.message,
                  type: "error",
                  duration:1500,showClose: true
              });
            }
      })
    },

      get_class(){
        var formData = new FormData();
        this.axios.get("/bank/system/v1.0/teacher/classes", formData).then(res => {
          // console.log(res)
      
            if (res.data.code == 200) {
                this.class_lsit=res.data.data
                if(this.class_lsit.length){
                  this.get_current_class()
                }
            } else {
              this.$message({
                  message: res.data.message,
                  type: "error",
                  duration:1500,showClose: true
              });
            }
        });
      },
      //根据班级id获取学生
      get_current_class(item){
       
        // 点击
        if(item){
          // console.log(item)
          this.current_class=item
          this.current_class_id=item.id
           
        }else{
          // 默认
          this.current_class=this.class_lsit[0]
          this.current_class_id=this.class_lsit[0].id
          
        }
        // 获取学生列表
          var formData ={
            page:this.page_num,
            size:this.page_size,
          }
          if(this.order_by){
            if(this.order_type=='ascending'){
              formData.orderType='asc'
            }else{
              formData.orderType='desc'
            }
            formData.orderBy=this.order_by
          }
          if(this.search_name){
            formData.keyword=this.search_name
          }
          this.axios.get("/bank/system/v1.0/class/"+this.current_class_id+"/students", {params:formData}).then(res => {
            if (res.data.code == 200) {
                // console.log(JSON.parse(JSON.stringify(res.data.data)))
                this.student_details_list=res.data.data
                this.student_total=parseInt(res.data.option)
            } else {
              this.$message({
                  message: res.data.message,
                  type: "error",
                  duration:1500,showClose: true
              });
            }
          })
      },
    
  }
    
   
};
</script>
<style >
 
</style>
<style scoped>
    .wrapper{
        margin: 14px 360px;
        /* background:#ffffff; */
        height: calc(100vh - 152px);
        overflow: auto;
        border-radius: 12px;
        overflow: hidden;
        /* padding:20px 0; */
    }
     .add_course_head{
    padding: 0 20px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 60px;
    /* padding-top: 17px; */
    margin-bottom: 17px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(204, 204, 204, 0.5);
    border-radius: 8px;
  }
  .add_course_head img{
    display: block;
    width: 24px;
    height: 20px;
    margin: 20px 0;
    cursor: pointer;
  }
  .content{
        height: calc(100vh - 304px);
        display: flex;
        justify-content: space-between;
    }
    .class_list{
        width: 280px;
        background: #FFFFFF;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        
    }
    .class_list_head{
        height: 60px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        overflow: hidden;
    }
    .class_list_head>div{
        height: 40px;
        background: #DDDDDD;
        border-radius: 10px;
        line-height: 40px;
        padding: 0 20px;
        margin: 10px 0;
        color: #999999;
        cursor: pointer;
    }
    .class_list_head_active{
        background: #69B4FF !important;
        color: white !important;         
    }
    .class_list_content{
        flex: 1;
        overflow: auto;
    }
    .class_list_foot{
        height: 44px;
        line-height: 44px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FF9B36;
        text-align: center;
        cursor: pointer;
        border-top: 1px #f2f2f2 solid;
    }
    .class_list_content_item{
        padding: 0 6px;
        border-left: 5px solid transparent;
        margin: 5px ;
        cursor: pointer;
        
    }
    .class_list_content_item span{
        color: #FF9B36 !important;
    }
    .class_list_operation{
        color: #999999;
        display: flex;
    }
    .class_list_operation>i{
        display: block;
        margin-right: 5px;
        cursor: pointer;
    }
    .current_class{
        border-color: #69B4FF !important;
        background: rgba(154, 205, 255, 0.36) !important;
        color:#69B4FF !important
    }
    .content_right{
       width: 900px;
       display: flex;
       flex-direction: column;
    }
    .right_head{
        background: #FFFFFF;
        border-radius: 12px;
        height: 56px;
        line-height: 56px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        box-sizing: border-box;
        margin-bottom: 20px;
    }
    .right_head_operation {
        display: flex;
    }
    .right_head >div:nth-of-type(1){
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #69B4FF;
    }

    .right_setting{
        height: 36px;
        background: #FF9B36;
        border-radius: 10px;
        padding: 0 20px;
        line-height: 36px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
         margin: 10px 10px;
         cursor: pointer;
    }
    .right_remove{
         height: 36px;
        background: #F8F8F8;
        border-radius: 10px;
        padding: 0 20px;
        margin: 10px 10px;
        line-height: 36px;
        cursor: pointer;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    .right_table{
        flex: 1;
        overflow: auto;
        background: #FFFFFF;
        border-radius: 12px 12px 0 0;
    }
    .operation_btn{
        height: 30px;
        border: 1px solid #5CADFF;
        border-radius: 7px;
        line-height: 30px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #69B4FF;
        margin-right: 15px;
        /* padding: 0 10px; */
        cursor: pointer;
        width: 120px;
        text-align: center;
        margin-bottom: 10px;
    }
    .select_student{
        margin-top: 20px;
    }


    /* 座位表 */
  .active_left_student{
    background: #FFCC4A !important;
    border-color: #FFCC4A !important;
  }
  .setingPlan_content{
    display: flex;
    height: 50vh;
  } 
  .setingPlan_content_left{
    width: 49.25%;
    
  }
  .setingPlan_content_left_top{
    height: calc(60vh - 105px);
    border:1px solid rgba(152,190,249,1);
    border-radius:4px;
    margin-bottom: 10px;
    padding: 10px;
    padding-right: 0;
    display: flex;
    overflow-x:scroll ;
  }
  .setingPlan_content_right{
    /* min-height: 40vh; */ 
    width: 49.25%;
    margin-left: 1.5%;
    /* display: flex; */
    flex: 1;
    /* justify-content: space-between;s */
  }
  .setingPlan_content_right_content{
    border:1px solid rgba(152,190,249,1);
    border-radius:4px;
    flex-wrap: wrap;
    padding:0 10px 10px 0;
    box-sizing: border-box;
  }
  .setingPlan_content_right_name{
    width:calc((100% - 60px )/6) ;
    height:26px;
    background:rgba(152,190,249,1);
    border-radius:2px;
    text-align: center;
    line-height: 26px;
    font-size: 12px;
    color: #ffffff;
    margin: 10px;
    margin-right: 0;
    margin-bottom: 0;
    cursor: pointer;
    border: 1px solid rgba(152,190,249,1);
    box-sizing: border-box;
  }
  .setingPlan_content_left_top_name{
    width: 60px;
    height: 26px;
    border-radius:2px;
    text-align: center;
    line-height: 26px;
    font-size: 12px;
    color: #98BEF9;
    margin:0 10px 10px 0;
    cursor: pointer;
    border: 1px solid rgba(152,190,249,1);
    box-sizing: border-box;
  }

  .setingPlan_content_left_fot{
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    display: flex;
  }
  .setingPlan_content_left_fot img{
    width:14px ;
    height:14px ;
    display: inline-block;
    margin-left:5px ;
    align-self:center;
    cursor: pointer;
  }
.setingPlan_content_left_fot button {
  background: #FFCC4A;
  color: #fff;
  border: 0;
  border-radius: 2px;
  margin-left: 10px;
  cursor: pointer;
  outline:none;
}
.tool_list_box{
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.tool_list_item{
  padding: 0 20px;
  padding-bottom: 20px;
  border-right:1px solid #cccccc;
}
.student_pagination{
  text-align:right;
  background:white;
  padding-top:10px;
  border-radius:0 0 12px 12px;
}

</style>
